import React, { useState, useEffect } from 'react';
import {
    Link,
    useLocation,
    useHistory,
   /*  Redirect */
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { servicesReplaced, servicesSelector } from '../../../../store/reducers/selServReducer';
import { classAdded, scrollSelector } from '../../../../store/reducers/scrollReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer';

function SelectServicesLarge({ companyInfo }) {
    const scroll = useSelector(scrollSelector);
    const promoCode = useSelector(promoCodeSelector);
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedServices = useSelector(servicesSelector);
    const params = new URLSearchParams(location.search);
    const [scrollClass, setScrollClass] = useState(scroll);
    const summary = params?.get("summary");
    let history = useHistory();
    const [magnet, setMagnet] = useState("Magnet JQS HuRi-Only");
    const [promoCodeIs, setPromoCodeIs] = useState(false);
    const [fromSummary, setfromSummary] = useState(false);
    const registrationData = useSelector(registrationSettingsSelector);

    useEffect(() => { 
        if(promoCode.isHuri === true) {
            setPromoCodeIs(true);
        } else {
            setMagnet("Magnet JQS Basic");
        }
        if(summary) {
            setfromSummary(summary);
        }
    }, []); // eslint-disable-line

    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container large") ; }, 10);
    }, []); // eslint-disable-line

    function handleNext(e) {
        if(promoCodeIs === true) {
            if(summary && e.target.classList[0] === "summaryNavButton") {
                dispatch(classAdded("progression_container large startBottom"));
                if(selectedServices.length <= 0) {
                    dispatch(servicesReplaced(magnet));
                }
                dispatch(pathAdded(history.location.pathname));
                history.push("/form/summary");
            } else {
                dispatch(pathAdded(history.location.pathname));
                if(selectedServices.length <= 0) {
                    dispatch(servicesReplaced(magnet));
                }
                dispatch(classAdded("progression_container large startBottom"));
                history.push("/form/info");
            }
        } else {
            if(summary && e.target.classList[0] === "summaryNavButton") {
                dispatch(classAdded("progression_container large startBottom"));
                dispatch(pathAdded(history.location.pathname));
                dispatch(servicesReplaced(magnet));
                history.push("/form/summary");
            } else {
                dispatch(pathAdded(history.location.pathname));
                dispatch(servicesReplaced(magnet));
                dispatch(classAdded("progression_container large startBottom"));
                history.push("/form/info");
            } 
        }
    };

    return (
        <>  
            {/* {companyInfo.name === "" ?  <Redirect to="register/#/" /> : null } ?? Add redirect? */} 
            <Link to="/" className="previous large">Find company <span>
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                </svg>
            </span></Link>  
            <div className="form-choosenCompany"><span className="your-company-text">Your company:</span> {companyInfo?.name !== "" && <span>{companyInfo.name}</span>}</div> 
            <div className={scrollClass}>  

                {promoCodeIs ?
                    <>
                        <h2>Confirm service</h2>
                        <div className="services-huri">
                            <p>Service:</p> 
                            <p className="service clicked">Magnet JQS HuRi-Only</p>
                        </div>
                        <p>
                            Your company will be nominated for a Human Rights assessment by one of your clients.</p>
                        <p>
                        <br/>
                            The assessment will be conducted through an industry collaboration and this service is coordinated by Offshore Qualific.
                        </p>
                        <br/>
                        <p>
                            This industry approach allows you to demonstrate respect for human rights towards other potential clients, and to obtain timesaving assessments processes.
                        </p>
                        <br/>
                        <p>
                            Once you have been successfully onboarded, the Requestor will be notified and confirm the nomination. You will receive a system notification with instructions once the nomination has been confirmed.
                        </p></>
                    :<>
                        <h2>Confirm service</h2>
                        { registrationData.registration_text ? 
                            <>
                                <p className="fee">{registrationData.registration_text}</p>
                                <p className="fee-bottom">{registrationData.registration_text_bottom}</p>
                            </>
                            :
                            <p className="fee">Please note that there is a yearly service fee of NOK 5 700 (excl. VAT) for access to Magnet JQS Basic</p>
                        }
                    </>
                }

                <div className="button_container select">
                    <button onClick={handleNext} className="nextSubmit next plausible-event-name=Registration+Confirm+Services"><span>Next</span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </button>
                    {fromSummary && <button className="summaryNavButton" onClick={handleNext} type="submit">Back to summary</button>}
                </div>
            </div>
        </>
    );
}

export default SelectServicesLarge;
